<template>
    <b-row no-gutters class="login-row">
        <b-col align-self="center" class="px-3 text-center">
            <br>
            <img :src="logo" alt="logo-moregiros" class="logo-small">
            <b-form id="formReset" @submit.stop.prevent="submit" class="form-signin mt-4 mb-2">
                <p class="mb-4 d-block text-secondary">{{ labels.text }}</p>
                <b-form-group>
                    <b-form-input
                        id="password"
                        ref="password"
                        name="password"
                        type="password"
                        v-model="form.password"
                        class="text-center"
                        :placeholder="labels.password"
                        v-validate="{ required: true, min: 8 }"
                        :state="validateState('password')"
                        aria-describedby="password-live-feedback"
                        :data-vv-as="(labels.password).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="password-live-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        v-model="form.password_confirmation"
                        class="text-center"
                        :placeholder="labels.password_confirmation"
                        v-validate="{ required: true, confirmed: 'password', min: 8 }"
                        :state="validateState('confirmPassword')"
                        aria-describedby="confirm-password-live-feedback"
                        :data-vv-as="(labels.password_confirmation).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="confirm-password-live-feedback">{{ veeErrors.first('confirmPassword') }}</b-form-invalid-feedback>
                </b-form-group>
            </b-form>
        </b-col>

        <!-- login buttons -->
        <b-row class="mx-0 bottom-button-container">
            <b-col>
                <b-button type="submit" variant="default" size="lg" pill block class="shadow"
                          form="formReset" :disabled="loading">
                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                    <span aria-hidden="true" v-else>
                        <i class="mdi mdi-shield-key"></i>
                    </span>
                    <span class="v-align-baseline">{{ loading ? labels.load : labels.login }}</span>
                </b-button>
            </b-col>
        </b-row>
        <!-- login buttons -->
    </b-row>
</template>

<script>
import axios from 'axios';

export default {
    name: "Reset",
    data: () => ({
        logo: '/img/logo_login.png',
        passwordHidden: true,
        labels: {
            text: 'Ingrese una nueva contraseña a continuación.',
            password: 'Nueva Contraseña',
            password_confirmation: 'Confirmar Contraseña',
            load: 'Actualizando...',
            login: 'Actualizar'
        },
        form: {
            token: null,
            email: null,
            password: null,
            password_confirmation: null
        },
        loading: false
    }),
    created() {
        this.form.email = this.$route.query.email;
        this.form.token = this.$route.params.token;
    },
    mounted() {
        this.loginRow();
        window.addEventListener("resize", this.loginRow);
        this.$emit('loader');
    },
    methods: {
        loginRow() {
            $('.login-row').css('min-height', ($(window).height() - 80));
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.form = {
                email: null,
                password: null
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                axios.post('/api/password/reset', this.form).then((res) => {
                    let msg = 'La contraseña se ha cambiado correctamente.';
                    this.$root.$bvToast.toast(msg, {
                        title: 'Felicitaciones',
                        headerClass: 'd-none',
                        variant: 'success',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.success();
                }).catch(err => {
                    this.loading = false;
                });
            });
        },
        success() {
            this.$router.push({ name: 'Login' });
        }
    }
}
</script>

<style scoped>

</style>
